import React from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  IconButton,
  CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import RemoveIcon from '@mui/icons-material/Remove';
import SearchableDataTable from '../../components/SearchableDataTable';

const EntityTable = ({
  entities,
  columns,
  loading,
  selectedRows,
  onSelectionChange,
  onAddNew,
  onDeleteSelected,
  onExport,
  onImport,
  onRefresh,
  fileInputRef,
  handleFileChange,
  importing = false
}) => {
  return (
    <Box className="main-content">
      <Box className="toolbar-container">
        <Box className="selection-info" sx={{ pl: 0 }}>
          <Typography variant="h6" className="page-title" sx={{ pl: 0, fontWeight: 'bold' }}>Manage Entities</Typography>
          {selectedRows.length > 0 && (
            <Typography variant="body2" className="selection-info" sx={{ ml: 2 }}>
              {selectedRows.length} row{selectedRows.length !== 1 ? 's' : ''} selected
            </Typography>
          )}
        </Box>
        <Box className="button-group">
          <Button
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon />}
            className="action-button"
            onClick={onExport}
          >
            Export
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={importing ? <CircularProgress size={16} color="inherit" /> : <UploadIcon />}
            className="action-button"
            onClick={onImport}
            disabled={importing}
          >
            {importing ? 'Importing...' : 'Import'}
          </Button>
          {/* Hidden file input for Excel import */}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept=".xlsx, .xls"
          />
          <Button
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            onClick={onAddNew}
            className="action-button"
          >
            Add
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<RemoveIcon />}
            onClick={onDeleteSelected}
            disabled={selectedRows.length === 0}
            className="action-button"
            sx={{
              '&.Mui-disabled': {
                opacity: 0.4, // Lower opacity when disabled
              }
            }}
          >
            Remove
          </Button>
        </Box>
      </Box>
      <Box className="table-container">
        <SearchableDataTable
          searchPlaceholder="Search Entities..."
          rows={entities}
          columns={columns}
          loading={loading}
          pageSize={15}
          tableName="entities-table"
          defaultSortField="code"
          defaultSortOrder="asc"
          defaultVisibleColumns={['code', 'name', 'region', 'country', 'currency', 'taxType', 'taxSubType', 'active', 'isTopSide', 'isTopSideUS', 'isBranch']}
          onRefresh={onRefresh}
          checkboxSelection={true}
          selectionModel={selectedRows}
          onSelectionModelChange={onSelectionChange}
          height="100%"
          className="custom-datagrid"
        />
      </Box>
    </Box>
  );
};

export default EntityTable;
